import Module from '../lib/module';

export default class FileOrganizer extends Module {
  setup() {
    this._updateState();
    this.bind();
  }

  get items() {
    return this.element.querySelectorAll('[data-role="organizer-item"]');
  }

  bind() {
    this.on('updated', (event) => {
      this._updateState();
    });

    this.on('click', '[data-action="remove"]', (event) => {
      const item = event.target.closest('[data-role="organizer-item"]');
      item.parentNode.removeChild(item);

      this._updateState();
    });

    this.on('click', '[data-action="move-up"]', (event) => {
      const item = event.target.closest('[data-role="organizer-item"]');
      const previousSibling = item.previousElementSibling;

      if (previousSibling && previousSibling.matches('[data-role="organizer-item"]')) {
        this.element.insertBefore(item, previousSibling);
      }

      this._updateState();
    });

    this.on('click', '[data-action="move-down"]', (event) => {
      const item = event.target.closest('[data-role="organizer-item"]');
      const nextSibling = item.nextElementSibling;

      if (nextSibling && nextSibling.matches('[data-role="organizer-item"]')) {
        this.element.insertBefore(nextSibling, item);
      }

      this._updateState();
    });
  }

  unbind() {
    this.off('updated');
    this.off('click', '[data-action="remove"]');
    this.off('click', '[data-action="move-up"]');
    this.off('click', '[data-action="move-down"]');
  }

  _updateState() {
    const items = [].slice.call(this.items);
    const firstIndex = 0;
    const lastIndex = Math.max(0, items.length - 1);

    items.forEach((item, index) => {
      item.querySelector('[data-action="move-up"]').disabled = (index == firstIndex);
      item.querySelector('[data-action="move-down"]').disabled = (index == lastIndex);
    });
  }
}
